import { h } from "preact";
import { useEffect, useRef } from "preact/hooks";

export function FileInput(props: {
    style?: string;
    accept?: string;
    onChange: (data: File[]) => void;
    reset?: number;
}) {
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if ((props.reset ?? 0) > 0 && ref.current) {
            ref.current.value = "";
            ref.current.closest("form")?.reset();
        }
    }, [props.reset]);

    return (
        <span>
            <input
                ref={ref}
                style={props.style}
                type="file"
                accept={props.accept}
                class="p-0 file:border-r file:px-2 file:border-r-gray-500 file:bg-gray-500 file:mr-2"
                onChange={e => {
                    if (!e.currentTarget.files || e.currentTarget.files.length === 0) {
                        props.onChange([]);
                    } else {
                        props.onChange(Array.prototype.slice.call(e.currentTarget.files));
                    }
                }}
            ></input>
        </span>
    );
}
